import { on } from "delegated-events";

on('click', '[data-post-message]', (event) => {
  window.top?.postMessage(event.currentTarget.dataset.postMessage, window.origin);
});
